import { render, staticRenderFns } from "./delegate-approval-form.vue?vue&type=template&id=656994ca&"
import script from "./delegate-approval-form.vue?vue&type=script&lang=js&"
export * from "./delegate-approval-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports